import { Injectable } from '@angular/core';
import { locale, loadMessages } from "devextreme/localization";

@Injectable({
  providedIn: 'root'
})

// 本地化設置
export class LocalizationService {

  constructor() {
    this.setupLocalization();
  }

  private setupLocalization() {
    loadMessages({
      "zh-tw": {
        "Yes": "是",
        "No": "否",
        "dxDataGrid-editingDeleteRow": "刪除",
        "dxDataGrid-editingSaveRowChanges": "儲存",
        "dxDataGrid-editingCancelRowChanges": "取消",
      }
    });
    locale("zh-tw"); // 設定為繁體中文
  }
}
